/**
 * Download file.
 * @param {*} data Binary data.
 */
function download(data) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `data.xlsx`);
  document.body.appendChild(link);
  link.click();
}

export { download };
